import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, OnDestroy } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { PermissionService } from './permission.service';
import { environment } from '../../../environments/environment';
import { IResponse } from '../models/iresponse';
import { Users } from '../models/users';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  API_URLGetUsers = `${environment.apiUrl}/Users/GetUsers`;
  API_URLUpdateUserRoles = `${environment.apiUrl}/Users/UpdateUserRoles`;
  API_URLActivateDeactivate = `${environment.apiUrl}/Users/ActivateDeactivateUser`;
  API_URLActivateUser = `${environment.apiUrl}/Users/ActivateUser`;
  API_URLChangeData = `${environment.apiUrl}/Users/ChangeData`;
  API_URLGetOtpFromDB = `${environment.apiUrl}/GetOPT/GetOtpFromDB`;

  constructor(
    private http: HttpClient,
    private permissionService:PermissionService) {
  }

  
  GetUsers(body:any): Observable<IResponse<Users>> {
    const url = this.API_URLGetUsers;
    //Http request
    return this.http.post<IResponse<Users>>(url,body)
  }

  UpdateUserRoles(body:any): Observable<any> {
    const url = this.API_URLUpdateUserRoles;
    //Http request
    return this.http.post<any>(url,body).pipe(
      catchError(err => {
        console.error('FIND ITEMS', err);
        return of({ dateSet: [] });
      })
    );
  }

  UpdateUserStatus(id:string,changeActiveStatus:boolean=false):Observable<any>{
    const url = changeActiveStatus ? this.API_URLActivateUser : this.API_URLActivateDeactivate;
    let data = {userId: id};
    //Http request
    return this.http.get(url,{params: data}).pipe(
      catchError(err => {
        console.error('FIND ITEMS', err);
        return of({ dateSet: [] });
      })
    );
  }

  AddRemoveAgent(online:any){
   
    if(this.permissionService.userRoles && this.permissionService.userRoles.includes("Agent")){
      // console.log("if")
      const url  = `${environment.apiUrl}/Users/AddRemoveAgent`;
      let data = {isAdd: online};
      //Http request
      this.http.get(url,{params: data}).subscribe()
    }else{
      console.log("else")
      return;
    }
   
  }

  ChangeData(body:any):Observable<any>{
    const url  = this.API_URLChangeData;
    //Http request
    return this.http.post(url,body);
  }

  GetOtpFromDB(phoneNumber: string): Observable<any> {
    const url = this.API_URLGetOtpFromDB;
    //Http request-
    return this.http.get<any>(url + `?phoneNumber=${phoneNumber}`).pipe(
      catchError(err => {
        console.error('FIND ITEMS', err);
        return of({ dateSet: [] });
      })
    );
  }

}
